import styled from 'styled-components'
import SyntaxHighlighter from 'react-syntax-highlighter/light'
import variables from '../../styles/variables'
import { ReactComponent as LoadingPink } from '../../svg-assets/loading-pink.svg'

export const Container = styled.div`
  width: 100%;
  height: 100%;
`

export const QueryBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0 10px;
  border-radius: 5px;

  @media ${variables.media.sm} {
    margin: 10px 0;
  }
`

export const BrowserContainer = styled.div`
  display: flex;
  justify-content: center;
  position: relative;
  margin-top: 30px;
`
export const Window = styled.div`
  transition: transform 0.25s ease-out;

  ${props => props.visible && `
    z-index: 2;
    transform: translate(10px, 10px);

    @media ${variables.media.sm} {
      transform: translate(20px, 22px);
    }
  `}

  ${props => !props.visible && `
    z-index: 0;
    transform: translate(-10px, -10px);

    @media ${variables.media.sm} {
      transform: translate(-20px, -22px);
    }
  `}
`

export const BackendWindow = styled(Window)`
`

export const FrontendWindow = styled(Window)`
  position: absolute;
`

export const LoadingIcon = styled(LoadingPink)`
  width: 40px;
  height: 196px;
  animation: fadeout 2s ease-in-out;
`

export const StyledSyntaxHighlighter = styled(SyntaxHighlighter)`
  animation: fadeIn 2s ease-in-out;
`
export const ResponseContainer = styled.div`
  border-top: 1px solid #525252;
  padding-top: 5px;
  margin-top: 5px;
`
